import type { UserInfo } from "@src/types";
import { documentToHash } from "@core/utils";

type UserInfoContext = {
  meta: {
    user_info: UserInfo
  }
}

// list of domains to avoid cors erros to fetch VTEX IO endpoint
export const PROD_DOMAINS: Record<string, Record<string, string>> = {
  "animale": {
    "store": "https://www.animale.com.br",
    "checkout": "https://secure.animale.com.br",
  },
  "lojafarm": {
    "store": "https://lojafarm.myvtex.com"
  },
  "mariafilo": {
    "store": "https://mariafilo.myvtex.com",
    "checkout": "https://secure.mariafilo.com.br",
  },
  "lojacrisbarros": {
    "store": "https://lojacrisbarros.myvtex.com",
    "checkout": "https://secure.crisbarros.com.br",
  },
  "lojaoffpremium": {
    "store": "https://lojaoffpremium.myvtex.com",
    "checkout": "https://secure.offpremium.com.br",
  },
  "bynv": {
    "store": "https://bynv.myvtex.com",
  },
  "lojafabula": {
    "store": "https://lojafabula.myvtex.com",
  },
};

export async function getUserInfo(context: UserInfoContext) {
  const domain = PROD_DOMAINS[context?.meta?.user_info?.account]?.[context?.meta?.user_info?.platform];

  if (!domain) return { customer: { email: context?.meta?.user_info?.userEmail, id: context?.meta?.user_info?.userId }, address: null };

  try {
    const api = `${domain}/_v/user-info`;
    const response = await fetch(api, {
      method: 'POST',
      body: JSON.stringify({ email: context?.meta?.user_info?.userEmail })
    });

    if (response.status !== 200) {
      // profile/edit and checkout route; we get the info directly from the input text
      if (context?.meta?.user_info?.manuallyInfo && context?.meta?.user_info?.manuallyInfo?.cpf) {
        const { cpf, birthDate, phone, firstName, lastName, email, email_optin } = context?.meta?.user_info?.manuallyInfo
        const document = cpf?.replace(/\D/g, '')
        const hashedDocument = await documentToHash(document)

        return {
          address: null,
          customer: {
            email,
            phone,
            document,
            lastName,
            birthDate,
            firstName,
            email_optin,
            homePhone: phone,
            cpf: hashedDocument,
          }
        };
      }

      return { customer: { email: context?.meta?.user_info?.userEmail, id: context?.meta?.user_info?.userId }, address: null };
    }

    const res = await response.json();
    const document = res?.customer?.document?.replace(/\D/g, '')
    const hashedDocument = await documentToHash(document)

    return { ...res, customer: { ...res.customer, cpf: hashedDocument, document } }
  } catch (_) {
    // profile/edit and checkout route; we get the info directly from the input text
    if (context?.meta?.user_info?.manuallyInfo && context?.meta?.user_info?.manuallyInfo?.cpf) {
      const { cpf, birthDate, phone, firstName, lastName, email, email_optin } = context?.meta?.user_info?.manuallyInfo
      const document = cpf?.replace(/\D/g, '')
      const hashedDocument = await documentToHash(document)

      return {
        address: null,
        customer: {
          email,
          phone,
          document,
          lastName,
          birthDate,
          firstName,
          email_optin,
          homePhone: phone,
          cpf: hashedDocument,
        }
      };
    }

    return { customer: { email: context?.meta?.user_info?.userEmail, id: context?.meta?.user_info?.userId }, address: null };
  }
}